import request from '@/utils/request'

const preUrl = "/dist";

export const reqListDict = (params) => {
    return request({
        url: preUrl + '/list', method: 'get', params
    })
}

export const reqInsertDict = (data) => {
    return request({
        url: preUrl + '/insert', method: 'post', data
    })
}
export const reqUpdateDict = (data) => {
    return request({
        url: preUrl + '/update', method: 'post', data
    })
}
export const reqDeleteDict = (params) => {
    return request({
        url: preUrl + '/delete', method: 'get', params
    })
}
export const reqGetConcatUs = (params) => {
    return request({
        url: '/sysConfig/detail?type=' + params, method: 'get'
    })
}
